<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 入账编號" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
				<!-- 	<el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">入账</el-button> -->
					<el-tag class="ml-3" type="warning">總流入：{{total_list.pay}}</el-tag>
					<el-tag class="ml-3" type="danger">總支出：{{total_list.get}}</el-tag>
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="入账编號" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索入账编號"></el-input>
						</el-form-item>
						
						<el-form-item label="编號" class="mb-0">
							<el-input size="small" v-model="from.number" placeholder="搜索流入/支出標號"></el-input>
						</el-form-item>
						
						<el-form-item label="方向" class="mb-0">
							<el-input size="small" v-model="from.bank" placeholder="搜索流入/支出方向"></el-input>
						</el-form-item>
						
						<el-form-item label="坐標" class="mb-0">
							<el-input size="small" v-model="from.name_s" placeholder="搜索流入/支出坐標"></el-input>
						</el-form-item>
						
						
						
					
						
		
						
						
					
					
				

					
						
					


						<el-form-item label="入账時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<!-- <el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column> -->
				
				
				<el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column>
			
				
				<el-table-column align="center" width="120" prop="shop_name" label="所属店铺"></el-table-column>
				<el-table-column align="center" width="120" prop="sad_name" label="入账店長"></el-table-column>
		
				
				<el-table-column width="210" align="center" prop="order_no" label="入账编號"></el-table-column>
				<el-table-column align="center" width="120" prop="number_s" label="流入编號"></el-table-column>
				<el-table-column align="center" prop="name_s" label="流入坐標"></el-table-column>
				<el-table-column align="center" prop="bank_s" label="流入方向"></el-table-column>
				<el-table-column align="center" width="100" prop="money_s" label="流入金額"></el-table-column>
				
				<el-table-column align="center"  width="100" prop="money_e" label="支出金額"></el-table-column>
				<el-table-column align="center" prop="bank_e" label="支出方向"></el-table-column>
				
				<el-table-column align="center" prop="name_e" label="支出坐標"></el-table-column>
							
				<el-table-column align="center" width="120" prop="number_e" label="支出编號"></el-table-column>
				
				
				
			
				
		
			
		
				<!-- 
				<el-table-column align="center" sortable="custom" prop="status"  label="狀態">
					<template slot-scope="scope">
						<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			 -->
		
			
				
	
			
				
				
	
				
		
				
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="入账時間">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="80" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">编辑</el-button>
							
						<!-- 	<el-button @click="deleteItem(scope.row)"  v-auth="'delRule'" size="mini" plain type="danger">删除</el-button> -->

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog  :close-on-click-modal="false" :title="editIndex==-1?'轉賬入账':'修改入账'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
	
		
				
			
				
				<el-form-item label="流入编號" prop="number_s">
					<el-input type="text" v-model="form.number_s" 
					placeholder="流入编號(No.)" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="流入坐標" prop="name_s">
					<el-input type="text" v-model="form.name_s" 
					placeholder="流入坐標(名稱)" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item label="流入方向" prop="bank_s">
					<el-input type="text" v-model="form.bank_s" 
					placeholder="流入方向(银行)" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="流入金額" prop="money_s">
					<el-input type="number" v-model="form.money_s" 
					placeholder="流入金額" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="支出金額" prop="money_e">
					<el-input type="number" v-model="form.money_e" 
					placeholder="支出金額" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item label="支出方向" prop="bank_e">
					<el-input type="text" v-model="form.bank_e" 
					placeholder="支出方向(银行)" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="支出坐標" prop="name_e">
					<el-input type="text" v-model="form.name_e" 
					placeholder="支出坐標(名稱)" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="支出编號" prop="number_e">
					<el-input type="text" v-model="form.number_e" 
					placeholder="支出编號(No.)" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
		
				
			
				
				
				
	
				
			
				
			
			
				
		
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		
		
		
		
		<el-dialog  :close-on-click-modal="false" title="申請修改入账" :visible.sync="applyModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules_apply" ref="formEdit" :model="applyData" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
			
				<el-form-item label="入账编號" prop="">
					<span>{{applyData.order_no}}</span>
				</el-form-item>
				
			
				
				<el-form-item label="申請原因" prop="remark">
					<el-input type="textarea" :rows="4" v-model="applyData.remark" 
					placeholder="請輸入申請原因" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
			

				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="applyModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules_apply:{
					remark: [{
							required: true,
							message: "請輸入申請修改原因",
							trigger: 'blur',
						},
					],
				},
				rules: {
					number_s: [{
							required: true,
							message: "請輸入流入编號",
							trigger: 'blur',
						},
					],
					name_s: [{
							required: true,
							message: "請輸入流入坐標",
							trigger: 'blur',
						},
					],
					bank_s: [{
							required: true,
							message: "請輸入流入方向",
							trigger: 'blur',
						},
					],
					money_s: [{
							required: true,
							message: "請輸入流入金額",
							trigger: 'blur',
						},
					],
					number_e: [{
							required: true,
							message: "請輸入支出编號",
							trigger: 'blur',
						},
					],
					name_e: [{
							required: true,
							message: "請輸入支出坐標",
							trigger: 'blur',
						},
					],
					bank_e: [{
							required: true,
							message: "請輸入支出方向",
							trigger: 'blur',
						},
					],
					money_e: [{
							required: true,
							message: "請輸入支出金額",
							trigger: 'blur',
						},
					],
					
					
				},
				applyModel: false,
				applyData:{
					id:0,
					order_no:'',
					remark:''
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					name_s:'',
					number:'',
					bank:'',
					time: [],
				},
				model_title: 'Zz',
				auth_val: 'Zz',
				preUrl: "user/zzList", //列表地址
				addUrl: "user/addZz", //添加/修改地址
				editStatusUrl: "user/editStatusZz", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					number_s:'',
					name_s:'',
					bank_s:'',
					money_s:'',
					number_e:'',
					name_e:'',
					bank_e:'',
					money_e:'',
					
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				
			
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			//this.commonList('costClass');
		},
		methods: {
			
			openapplyModel(e){
				this.applyData = {
					id:e.id,
					order_no:e.order_no,
					remark:''
				}
				this.applyModel = true
			},
			
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						
						
					
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						number_s:e.number_s,
						name_s: e.name_s,
						bank_s: e.bank_s,
						money_s: e.money_s,
						number_e:e.number_e,
						name_e: e.name_e,
						bank_e: e.bank_e,
						money_e: e.money_e,
					}
					this.editIndex = e.id
					
				
				}else{
					this.form = {
						id: 0,
						number_s:'',
						name_s:'',
						bank_s:'',
						money_s:'',
						number_e:'',
						name_e:'',
						bank_e:'',
						money_e:'',
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					name_s:'',
					number:'',
					bank:'',
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
